import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  containerformik:{
  margin:"25px 0px !important"
  },
  formikgrids:{
    padding:"14px 10px",
  },
  switchWrapper:{
    margin:"10px 14px !important",
  
  },
  roundedTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "25px",
    },
  },
}));

export default useStyles;
